import { render, staticRenderFns } from "./TraitMapping.vue?vue&type=template&id=b9135d40&lang=pug&"
import script from "./TraitMapping.vue?vue&type=script&lang=ts&"
export * from "./TraitMapping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports